module.exports = __webpack_public_path__ + "static/media/Oct19-17.97dd4c40.png";